/* global $$epiforms */

const formSection = document.querySelector(".adm-section-c32-popup");
const popupOpener = document.querySelector(".adm-btn-c32-popup-opener");
const popupElement = formSection.querySelector(".adm-div-c32-popup");
const pageMainTag = document.querySelector("main");
const epiServerForm = formSection.querySelector(".EPiServerForms");
const epiFormMainBody = formSection.querySelector(".Form__MainBody");
const formCloseBtn = formSection.querySelector(".adm-btn-c32-popup-close");
const formSubmitButton = formSection.querySelector(".FormSubmitButton");
const formTextareaWrapper = formSection?.querySelector(".FormTextbox--Textarea");
const formStatusSection = formSection?.querySelector(".Form__Status");
var submitErrorMessage = formSection?.getAttribute("data-submit-error");
const allFormSelections = formSection.querySelectorAll(".FormSelection");
const allFormInputs = formSection?.querySelectorAll(".FormTextbox");
const allFormErrorSpans = formSection.querySelectorAll(".Form__Element__ValidationError");
const submitBtnAriaLabel = formSection?.getAttribute("data-form-aria-submit");
const firstDropdownDefault = document.querySelector("input#MQ1")?.value?.trim();
const secondDropdownDefault = document.querySelector("input#MQ2")?.value?.trim();
let firstFocusableFormElement = epiFormMainBody?.querySelector("input, select, textarea, button");
formSection.removeAttribute("data-form-aria-submit");
formSection.removeAttribute("data-recaptcha-validation");

let formSubmissionErrorTag;
let scrollTop = 0;
let dataLayerObj = {};

setupDropdowns();
setupInputs();
addEventListenersToFormBtns();
replaceErrorSpanTag();
addCharCounterToTextarea();
addAriaLabelToElements();
setupLeadSourceDescription();
addFunctionsToNativeEpiformEvents();

// Lvl1 functions
function setupDropdowns() {
    for (const selectionWrapper of allFormSelections) {
        const selectTag = selectionWrapper.querySelector("select");

        if (firstDropdownDefault) {
            setupSecondDropdown(selectionWrapper, selectTag);
            setupFirstDropdown(selectTag);
        }

        selectTag.addEventListener("change", () => removeErrorOnInput(selectionWrapper));
        selectTag.addEventListener("focusout", () => removeRedOutlinePriority());
    }
}

function setupInputs() {
    for (const inputWrapper of allFormInputs) {
        const inputTag = inputWrapper.querySelector("input, textarea");

        inputTag.addEventListener("input", () => removeErrorOnInput(inputWrapper));
        inputTag.addEventListener("focusout", () => removeRedOutlinePriority());
    }
}

function addEventListenersToFormBtns() {
    popupOpener?.addEventListener("click", openPopup)
    formCloseBtn?.addEventListener("click", closeForm);
    formCloseBtn?.addEventListener("keydown", focusOnSubmitBtn);
    formSubmitButton?.addEventListener("keydown", focusOnCloseBtn);
}

function replaceErrorSpanTag() {
    for (const errorSpanTag of allFormErrorSpans) {
        errorSpanTag.parentElement.insertBefore(errorSpanTag, errorSpanTag.parentElement.firstElementChild.nextElementSibling);
    }
}

function addCharCounterToTextarea() {
    const textareaTag = formTextareaWrapper?.querySelector("textarea");
    const counterTag = document.createElement("SPAN");
    counterTag.innerText = "(0/1500)";
    counterTag.classList.add("textarea-counter");
    formTextareaWrapper?.appendChild(counterTag);
    textareaTag?.setAttribute("maxlength", "1500")
    formTextareaWrapper?.addEventListener("input", () => {
        const charCount = textareaTag.value.length;
        if (charCount <= 1500) {
            counterTag.innerText = `(${charCount}/1500)`;
        } else {
            const editedText = textareaTag.value.slice(0, 1500);
            textareaTag.value = editedText;
        }
    })
}

function addAriaLabelToElements() {
    formSubmitButton.setAttribute("aria-label", submitBtnAriaLabel);
    formSubmitButton.setAttribute("title", submitBtnAriaLabel);
}

function setupLeadSourceDescription() {
    const hiddenField = formSubmitButton.previousElementSibling;
    const sourceDescription = getSourceDescription();
    const fullNewValue = hiddenField?.getAttribute("value") + "-" + sourceDescription;
    hiddenField.setAttribute("value", fullNewValue);
}

function getSourceDescription() {
    const validUtmParamsKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_adgroup", "utm_experiment"];
    const currentPageUrl = `${location.origin}${location.pathname}`;
    const urlParams = new URL(document.URL).searchParams;
    let validUtmParamsString = "";

    validUtmParamsKeys.forEach(paramKey => {
        const paramValue = urlParams.get(paramKey);
        const isFirstValidParamFound = validUtmParamsString.length < 1;

        if (paramValue) {
            validUtmParamsString += `${isFirstValidParamFound ? "?": "&"}${paramKey}=${paramValue}`;
        }
    })

    return currentPageUrl + validUtmParamsString;
}

function addFunctionsToNativeEpiformEvents() {
    if (typeof $$epiforms !== 'undefined') {
        $$epiforms(document).ready(() => {
            $$epiforms(epiServerForm).on("formsStepValidating", () => {
                handleReadonlyMode();
                formSection.classList.add("adm-form-red-outline-priority");
            });

            $$epiforms(epiServerForm).on("formsStartSubmitting", () => {
                setupDataLayerObj();
            });

            $$epiforms(epiServerForm).on("formsSubmitted", (e) => {
                formSubmissionErrorTag?.remove();
                if (!e.isSuccess) {
                    submitErrorMessage = sliceAfterWord(e.returnedResult?.message, "Reason: ")
                    showErrorMessage();
                    popupElement.parentElement.scroll({ top: 0, behavior: "smooth" });
                } else {
                    formSection.classList.add("form-submitted");
                    popupElement.parentElement.scroll({ top: 0, behavior: "smooth" });
                    pushDataLayer();
                }

            });

            $$epiforms(epiServerForm).on("formsSubmittedError", () => {
                showErrorMessage();
            });
        });
    }
}

// Lvl2 functions
function setupSecondDropdown(selectionWrapper, selectTag) {
    if (selectTag.getAttribute("title")?.trim()?.toLowerCase() === firstDropdownDefault.toLowerCase()) {
        selectionWrapper.classList.remove("hide");
        if (secondDropdownDefault) {
            selectTag.value = secondDropdownDefault;
            selectTag.dispatchEvent(new Event('change'));
        }
    }
}

function setupFirstDropdown(selectTag) {
    for (const option of selectTag?.options ?? []) {
        if (option.value === firstDropdownDefault) {
            selectTag.value = firstDropdownDefault;
            selectTag.dispatchEvent(new Event('change'));
        }
    }
}

function removeErrorOnInput(fieldWrapper) {
    const validationMessage = fieldWrapper.querySelector(".Form__Element__ValidationError");
    if (fieldWrapper.classList.contains("ValidationFail")) {
        fieldWrapper.classList.remove("ValidationFail")
        validationMessage.style.display = "none";
    }
}

function removeRedOutlinePriority() {
    if (formSection.classList.contains("adm-form-red-outline-priority")) {
        formSection.classList.remove("adm-form-red-outline-priority");
    }
}

function openPopup(event) {
    event.preventDefault();
    window.addEventListener("mousedown", onOutsideFormClick);

    scrollTop = window.scrollY;

    formSection.classList.add("adm-gateway-opened");
    document.body.classList.add("adm-body-no-scroll");

    pageMainTag.style["margin-top"] = `-${scrollTop}px`;
    setTimeout(() => {
        firstFocusableFormElement?.focus();
    }, 0);
}

function onOutsideFormClick(event) {
    const screenWidth = window.innerWidth;
    const clickPositionX = event.clientX;

    if (
        formSection.contains(event.target) &&
        !popupElement.contains(event.target) &&
        clickPositionX < screenWidth - 20
    ) {
        closeForm(event);
    }
}

function closeForm(event) {
    event?.preventDefault();
    window.removeEventListener("mousedown", onOutsideFormClick);

    formSection.classList.remove("adm-gateway-opened");
    document.body.classList.remove("adm-body-no-scroll");

    pageMainTag.style["margin-top"] = ``;
    window.scroll(0, scrollTop);
    setTimeout(() => popupOpener.focus(), 0);
}

function focusOnSubmitBtn (event) {
    const pressedKeyCode = event.which || event.keyCode;

    // TAB key press
    if (pressedKeyCode === 9 && event.shiftKey) {
        event.preventDefault();
        formSubmitButton.focus();
    }
}

function focusOnCloseBtn (event) {
    const pressedKeyCode = event.which || event.keyCode;

    // TAB key press
    if (pressedKeyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        formCloseBtn.focus();
    }
}

async function handleReadonlyMode() {
    const response = await fetch(window.location.origin + '/FormsPage/GetDatabaseReadonly/');
    const readonlyBoolean = await response.json();
    if (readonlyBoolean) {
        formSection.classList.add("adm-c32-popup-maintenance-mode");
    }
}

function showErrorMessage() {
    formSubmissionErrorTag = document.createElement("SPAN");
    formSubmissionErrorTag.innerText = submitErrorMessage;
    formSubmissionErrorTag.classList.add("adm-c32-popup-custom-error-message");
    formStatusSection.appendChild(formSubmissionErrorTag)
}

function sliceAfterWord(str, word) {
    let index = str.indexOf(word);
    return index !== -1 ? str.slice(index + word.length) : str;
}

function setupDataLayerObj() {
    const allVisibleSelects = formSection.querySelectorAll(".FormSelection:not(.hide) select");
    const allInputElements = formSection.querySelectorAll(".FormTextbox input");
    const colectedData = [];

    colectedData.push(['event', 'contactuspopupformsuccess']);
    colectedData.push(['email_address', allInputElements[2]?.value?.toLowerCase()]);
    colectedData.push(['phone_number', allInputElements[3]?.value?.toLowerCase()]);
    colectedData.push(['industry_primary_selected', allVisibleSelects[0]?.value?.toLowerCase()]);

    if (allVisibleSelects.length > 2) {
        colectedData.push(['industry_sub_selected', allVisibleSelects[1]?.value?.toLowerCase()]);
    }

    dataLayerObj = {};
    for (const data of colectedData) {
        if (data[1]) {
            dataLayerObj[data[0]] = data[1];
        }
    }
}

function pushDataLayer() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerObj);
}